import type * as API from '~/types/api'
import type { Invoice } from '~/types/auth'

import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

export interface ParametersGetAll {
  limit?: number
  status?: string
}

export interface CollectInvoicesPayload {
  invoices: Pick<Invoice, 'id'>[]
  stripePaymentIntentId: string
}

export const useFetchInvoices = () => {
  const url = (workspaceId: string) => `/me/companies/${workspaceId}/invoices`

  const { get, post } = useFetchWithDefaults()

  const getAll = ({ workspaceId, params }: WorkspaceIdentifier & { params?: ParametersGetAll }) => get<API.v1.Response<Invoice[]>>({
    url: url(workspaceId),
    workspaceId,
    fetchOptions: {
      params,
    },
  })

  const getPdf = ({ workspaceId, invoiceHashId }: WorkspaceIdentifier & { invoiceHashId: string }) =>
    get<API.v1.Response<{ url: string }>>({
      url: `${url(workspaceId)}/${invoiceHashId}/pdf`,
      workspaceId,
    })

  const collect = ({ workspaceId, payload }: WorkspaceIdentifier & { payload: CollectInvoicesPayload }) => post({
    url: `${url(workspaceId)}/collect`,
    workspaceId,
    fetchOptions: {
      body: payload,
    },
  })

  return {
    getAll,
    collect,
    getPdf,
  }
}
